<template>
  <div class="user-managed">
    <div
      v-loading="tableLoading"
      class="um-main"
    >
      <sw-table
        :show-selection="false"
        :table-name="'flow-design'"
        :table-data="tableData"
        :table-title="tableTitle"
        :table-operation="tableOperation1"
        :page-sizes="[10,15,20]"
        :total-count="tableCount"
        :page-size="pageSize"
        :conflict-operation="conflictOperation"
        :has-add-button="false"
        @operation-handle="operationHandle"
        @size-change="changeSize"
        @change-page="changePage"
        @next-page="changePage"
        @prev-page="changePage"
      >
        <template
          slot="customcolumn"
          slot-scope="scope"
        >
          <span
            v-if="scope.item.prop=='textState'"
            :class="{'sw-table-active':scope.row.textState === '已发布', 'sw-table-unpublish': scope.row.textState === '未发布', 'sw-table-inactive': scope.row.textState === '已过期'}"
          >{{ scope.row.textState }}</span>
          <span
            v-else
            :title="scope.row[scope.item.prop]?scope.row[scope.item.prop]:'-'"
            class="swTableCell"
          >{{ scope.row[scope.item.prop]?scope.row[scope.item.prop]:'-' }}</span>
        </template>
      </sw-table>
    </div>

    <sw-dialog
      :title="dialogTitle"
      :visible.sync="dialogIframeVisible"
      :destroy-on-close="true"
      :before-close="handleDialogClose"
      top="50px"
      width="80vw"
    >
      <iframe
        :src="iframeSrc"
        style="border: none; width:  100%; height: calc(100vh - 145px)"
      />
    </sw-dialog>
  </div>
</template>

<script>
// import Divider from '@/views/formflow/components/divider'
import service, { FORMFLOW_CAS, FLOW_DESIGN_URL, FLOW_DESIGN_V3 } from '@/utils/service.js'
import { parseTime } from '@/utils/index.js'
import '@/views/formflow/css/appflow/basicdata/userManaged.scss'

export default {
  // components: {
  //   Divider
  // },
  data () {
    return {
      tableLoading: false,
      dialogTitle: '',
      iframeSrc: '',
      dialogIframeVisible: false,
      tableData: [],
      tableTitle: [
        { prop: 'NAME_', label: '流程名称', width: '120', sortable: true },
        {
          prop: 'fhactVersion',
          label: '流程版本',
          width: '120',
          sortable: true
        },
        {
          prop: 'create_time',
          label: '创建时间',
          width: '120',
          sortable: true
        },
        { prop: 'textState', label: '状态', width: '120', sortable: true }
      ],
      tableOperation1: [
        { name: '发布', icon: 'su-icon-print', operation: 'publish' },
        { name: '设计', icon: 'su-icon-edit', operation: 'edit' },
        { name: '查看', icon: 'su-icon-details', operation: 'look' },
        { name: '热发布', icon: 'su-icon-zhongxinfasong', operation: 'publishhot' }
      ],
      conflictOperation: {
        publish: { prop: 'operation', value: ['detail', 'edit-detail'] },
        publishhot: { prop: 'operation', value: ['detail', 'edit-detail'] },
        edit: { prop: 'operation', value: ['detail'] },
        detail: { prop: 'operation', value: ['publish-edit'] }
      },
      tableCount: 0,
      pageSize: 10,
      currentPage: 1,
      isClick: true // 用于限制发布按钮被多次点击
    }
  },
  computed: {
    pageVisible () {
      return this.$store.state.appflow.pageVisible
    }
  },
  watch: {
    pageVisible (val) {
      if (val) {
        this.getData()
      }
    }
  },
  mounted () {
    this.getData()
    // if (Number(FLOW_DESIGN_V3_VISIBLE) === 1) {
    //   this.tableOperation1.unshift({ name: '新版流程设计', icon: 'su-icon-waibulianjie', operation: 'link' })
    // }
  },
  methods: {
    handleDialogClose (done) {
      this.$swConfirm('确认是否关闭？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.getData()
        done()
      }).catch(() => {

      })
    },
    getData () {
      this.tableLoading = true
      service
        .get('/v1/application/getAct', {
          params: {
            fid: this.$route.params.fid,
            page: this.currentPage,
            limit: this.pageSize
          }
        })
        .then(res => {
          this.tableLoading = false
          this.tableData = res.data.map(item => {
            if (item.deployId) {
              if (item.highestPVersion) {
                item['textState'] = '已发布'
                item['operation'] = 'detail'
                if (item.highestVersion) {
                  item['operation'] = 'edit-detail'
                }
              } else {
                item['textState'] = '已过期'
                item['operation'] = 'detail'
              }
            } else {
              item['textState'] = '未发布'
              item['operation'] = 'publish-edit'
            }
            item.create_time = parseTime(item.create_time)
            return item
          })
          this.tableCount = res.count
        })
        .catch(error => {
          this.$swMessage.error(error)
        })
    },
    changeSize (size) {
      this.pageSize = size
      this.currentPage = 1
      this.getData()
    },
    changePage (page) {
      this.currentPage = page
      this.getData()
    },
    searchHandle () { },
    operationHandle (id, operation) {
      switch (operation) {
        case 'publish':
          if (this.isClick) {
            this.isClick = false
            this.publishFlow(id)
          }
          break
        case 'publishhot':
          this.$msgbox({
            title: '消息',
            message: '请注意！该操作会影响线上实例',
            confirmButtonText: '确定发布',
            cancelButtonText: '取消',
            showCancelButton: true,
            type: 'warning',
            beforeClose: (action, instance, done) => {
              console.log(action)
              if (action === 'confirm') {
                instance.confirmButtonLoading = true
                instance.confirmButtonText = '执行中...'
                this.publishFlowHot(id, instance, done)
              } else {
                done()
              }
            }
          })

          break
        case 'edit':
          this.openFlowDialog(id, 'act-show')
          break
        case 'look':
          this.openFlowDialog(id, 'act-check')
          break
        default:
          console.log('detail')
      }
    },
    publishFlow (id) {
      const tempRow = this.tableData.find(item => {
        return item.id === id
      })
      service
        .post('/v1/formflow/deploymentFormFlow', {
          id: id,
          modelId: tempRow.modelId
        })
        .then(res => {
          this.$swMessage({
            message: res.msg,
            type: 'success'
          })
          this.getData()
          this.isClick = true
        })
        .catch(error => {
          this.$swMessage.error(error)
          this.isClick = true
        })
    },
    publishFlowHot (id, instance, done) {
      const tempRow = this.tableData.find(item => {
        return item.id === id
      })
      service
        .get('/v1/formflow/actHotDeploy', {
          params: {
            id: id,
            modelId: tempRow.modelId
          }
        })
        .then(res => {
          instance.confirmButtonLoading = false
          done()
          this.$swMessage({
            message: res.msg,
            type: 'success'
          })
          this.getData()
        })
        .catch(error => {
          done()
          this.$swMessage.error(error)
        })
    },
    openFlowDialog (id, type) {
      const tempRow = this.tableData.find(item => {
        return item.id === id
      })
      this.dialogTitle = '流程设计-' + tempRow.NAME_
      let redirectUri = ''
      redirectUri = `${FLOW_DESIGN_V3}/?modelId=${tempRow.modelId}&fid=${tempRow.id}&type=${type}&token=${localStorage.getItem('Admin-Token')}`
      // redirectUri = `${FLOW_DESIGN_URL}/static/${type}.html?modelId=${tempRow.modelId}&fid=${tempRow.id}&from=adminplatform&time=${Date.now()}&token=` + localStorage.getItem('Admin-Token')
      this.iframeSrc = FORMFLOW_CAS + '?redirect_uri=' + encodeURIComponent(redirectUri)
      // this.dialogIframeVisible = true
      console.log(',,,')
      console.log(this.iframeSrc)
      window.open(redirectUri, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
.sw-table-unpublish {
  font-size: 12px;
  color: #f5a623;
  line-height: 22px;
  &:before {
    width: 8px;
    height: 8px;
    background: #f5a623;
    border-radius: 4px;
    display: inline-block;
    content: "";
  }
}
</style>
